import React from 'react';
import {createListCollection, Portal, Select} from "@chakra-ui/react";
import {Field} from "@/components";
import {useTranslation} from "react-i18next";

export const SelectView = ({ choices, label, required, conditional, onChange,...props }) => {

    const { t } = useTranslation();

    const collection = createListCollection({
        items: choices.map((e) => ({
            value: e,
            label: e
        }))
    })

    return (
        <Field
            label={`${label}${required ? '*' : ''} :`}
            {...props}
        >
            <Select.Root
                defaultValue=""
                collection={collection}
                onValueChange={e => onChange?.(e?.value[0])}
            >
                <Select.HiddenSelect/>
                <Select.Control>
                    <Select.Trigger>
                        <Select.ValueText placeholder={t('sentences.chooseFieldType')}/>
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator/>
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    <Select.Positioner>
                        <Select.Content>
                            {collection.items.map((item) => (
                                <Select.Item item={item} key={`select-item-${item.value}`}>
                                    {item.label}
                                    <Select.ItemIndicator/>
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
        </Field>
    );
};

export default SelectView;
